// The activity log's notion of "now" for values the server checks or that
// select stored entries (expiry, retention, period filters): the browser clock
// corrected by the offset the dashboard already synchronizes with the server
// (CustomHooks/useServerTime, same as AuthContext DateNow). It only corrects
// a known offset; an unsynchronized device still uses its own clock. The
// event's clientTime stays the raw, unconfirmed browser time.
import { readServerTimeDifference } from 'CustomHooks/useServerTime';

export const serverNow = () => Date.now() + readServerTimeDifference();
